export const TRANSLATE_LOADING_ACTION = "Loading set before action.";
export const TRANSLATE_LOGIN_SUCCESS_ACTION = "User was logged successfully.";
export const TRANSLATE_LOGIN_ERROR_ACTION = "Error during login user.";
export const TRANSLATE_REGISTRATION_SUCCESS_ACTION = "User was registered successfully.";
export const TRANSLATE_REGISTRATION_ERROR_ACTION = "Error during registration of user.";
export const TRANSLATE_RESET_PASSWORD_SUCCESS_ACTION = "Password reset successfully.";
export const TRANSLATE_RESET_PASSWORD_ERROR_ACTION = "Error during reset password.";
export const TRANSLATE_SIGN_IN = "Sign In";
export const TRANSLATE_SIGN_UP = "Sign Up";
export const TRANSLATE_LOGIN_FORGOT_PASSWORD = "Forgot password?";
export const TRANSLATE_LOGIN_DONT_HAVE_ACCOUNT = "Don't have an account?";
export const TRANSLATE_REGISTRATION_AGREE_WITH_TERMS = "Agree with terms and conditions";
export const TRANSLATE_RESET_PASSWORD = "Reset Password";
export const TRANSLATE_APPLICATION = "Application";
export const TRANSLATE_TIER3 = "Tier 3";
export const TRANSLATE_ME_MANAGER = "Me Manager";
export const TRANSLATE_PRODUCTION_PLANNING = "Production Planning";
export const TRANSLATE_REPORTS = "Reports";
export const TRANSLATE_SETTINGS = "Settings";
export const TRANSLATE_LOGOUT = "Log Out";
export const TRANSLATE_GET_ISSUES_SUCCESS_ACTION = 'Issues were successfully loaded.';
export const TRANSLATE_GET_ISSUES_ERROR_ACTION = 'Error during loading issues.';
export const TRANSLATE_DELETE_ISSUE_SUCCESS_ACTION = 'Issue was successfully deleted.';
export const TRANSLATE_DELETE_ISSUE_ERROR_ACTION = 'Error during deleting issue.';
export const TRANSLATE_GET_USERS_SUCCESS_ACTION = 'Users were successfully loaded.';
export const TRANSLATE_GET_USERS_ERROR_ACTION = 'Error during loading users.';
export const TRANSLATE_POST_USER_DATA_SUCCESS_ACTION = 'User was successfully saved.';
export const TRANSLATE_POST_USER_DATA_ERROR_ACTION = 'Error during saving user.';
export const TRANSLATE_YES = 'Yes';
export const TRANSLATE_NO = 'No';
export const TRANSLATE_IMAGE_USER = 'User photo';
export const TRANSLATE_GET_ROLES_SUCCESS_ACTION = 'Roles were successfully loaded.';
export const TRANSLATE_GET_ROLES_ERROR_ACTION = 'Error during loading roles.';
export const TRANSLATE_GET_USER_SUCCESS_ACTION = 'User was successfully loaded.';
export const TRANSLATE_GET_USER_ERROR_ACTION = 'Error during loading user.';
export const TRANSLATE_PATCH_USER_DATA_SUCCESS_ACTION = 'User was successfully changed.';
export const TRANSLATE_PATCH_USER_DATA_ERROR_ACTION = 'Error during changing user.';
export const TRANSLATE_UPLOAD_PHOTO = 'Upload photo';
export const TRANSLATE_DEACTIVATE_USER_SUCCESS_ACTION = 'User was successfully deactivated.';
export const TRANSLATE_DEACTIVATE_USER_ERROR_ACTION = 'Error during deactivating user.';
export const TRANSLATE_DELETE_ROLE_SUCCESS_ACTION = 'Role was successfully deleted.';
export const TRANSLATE_DELETE_ROLE_ERROR_ACTION = 'Error during deleting role.';
export const TRANSLATE_POST_ROLE_SUCCESS_ACTION = 'Role was successfully saved.';
export const TRANSLATE_POST_ROLE_ERROR_ACTION = 'Error during saving role.';
export const TRANSLATE_PATCH_ROLE_SUCCESS_ACTION = 'Role was successfully changed.';
export const TRANSLATE_PATCH_ROLE_ERROR_ACTION = 'Error during changing role.';
export const TRANSLATE_GET_ROLE_SUCCESS_ACTION = 'Role was successfully loaded.';
export const TRANSLATE_GET_ROLE_ERROR_ACTION = 'Error during loading role.';
export const TRANSLATE_GET_ISSUE_SUCCESS_ACTION = 'Issue was successfully loaded.';
export const TRANSLATE_GET_ISSUE_ERROR_ACTION = 'Error during loading issue';
export const TRANSLATE_PATCH_ISSUE_SUCCESS_ACTION = 'Issue was successfully changed.';
export const TRANSLATE_PATCH_ISSUE_ERROR_ACTION = 'Error during changing issue.';
export const TRANSLATE_ACTIVATE_USER_SUCCESS_ACTION = 'User was successfully activated.';
export const TRANSLATE_ACTIVATE_USER_ERROR_ACTION = 'Error during activating user.';
export const TRANSLATE_LOADING_CONTENT = 'Loading content';
export const TRANSLATE_USERS = 'Users';
export const TRANSLATE_CREATE_USER = 'Create user';
export const TRANSLATE_ROLES = 'Roles';
export const TRANSLATE_ROLE = 'Role';
export const TRANSLATE_CREATE_ROLE = 'Create role';
export const TRANSLATE_ROLE_NAME = 'Role name';
export const TRANSLATE_SAVE = 'Save';
export const TRANSLATE_CANCEL = 'Cancel';
export const TRANSLATE_EDIT_ROLE = 'Edit role';
export const TRANSLATE_LIST_OF_ROLES = 'List of roles';
export const TRANSLATE_ID = 'ID';
export const TRANSLATE_ADD_NEW_ROLE = 'Add new role';
export const TRANSLATE_ACTIVE = 'Active';
export const TRANSLATE_PHOTO = 'Photo';
export const TRANSLATE_FIRST_NAME = 'First Name';
export const TRANSLATE_LAST_NAME = 'Last Name';
export const TRANSLATE_EMAIL = 'E-mail';
export const TRANSLATE_PHONE = 'Phone';
export const TRANSLATE_EDIT_USER = 'Edit user';
export const TRANSLATE_LIST_OF_USERS = 'List of users';
export const TRANSLATE_ADD_NEW_USER = 'Add new user';
export const TRANSLATE_NAME = 'Name';
export const TRANSLATE_CREATED = 'Created';
export const TRANSLATE_NUMBER_OF_SHOWN_ISSUES = 'Number of shown issues';
export const TRANSLATE_QUESTION_DELETE_ISSUE = 'Do you really want to delete select with all its values?';
export const TRANSLATE_QUESTION_DELETE_ROLE = 'Do you really want to delete chosen role?';
export const TRANSLATE_QUESTION_DEACTIVATE_USER = 'Do you really want to deactivate chosen user?';
export const TRANSLATE_QUESTION_ACTIVATE_USER = 'Do you really want to activate chosen user?';
